import { render, staticRenderFns } from "./detailCastingCall.vue?vue&type=template&id=30993cd4&"
import script from "./detailCastingCall.vue?vue&type=script&lang=js&"
export * from "./detailCastingCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports